export const SET_SAMPLES = 'SET_SAMPLES';
export const SET_BAGS = 'SET_BAGS';
export const SET_PLATES = 'SET_PLATES';
export const SET_SAMPLES_LOADING = 'SET_SAMPLES_LOADING';
export const SET_SAMPLES_ERROR = 'SET_SAMPLES_ERROR';
